// V1.5 — Web client for admin dispute management.

import { apiClient } from './client';
import type { AdminDisputeItem } from '@leyrochain/shared';

export type { AdminDisputeItem };

export interface DisputesListResponse {
  open: AdminDisputeItem[];
  resolved: AdminDisputeItem[];
}

export async function listDisputes(): Promise<DisputesListResponse> {
  const { data } = await apiClient.get<DisputesListResponse>('/api/v1/admin/sales/disputes');
  return data;
}

export interface ResolveDisputeInput {
  saleId: string;
  resolution: 'BUYER' | 'SELLER';
  notes: string;
}

export async function resolveDispute(input: ResolveDisputeInput): Promise<{
  sale_id: string;
  status: string;
  refunded: boolean;
  rectificatives_emitted: number;
}> {
  const { data } = await apiClient.post<{
    sale_id: string;
    status: string;
    refunded: boolean;
    rectificatives_emitted: number;
  }>(`/api/v1/admin/sales/${encodeURIComponent(input.saleId)}/dispute/resolve`, {
    resolution: input.resolution,
    notes: input.notes,
  });
  return data;
}
